import * as types from "./mutation-types";

export default {
  [types.SET_NOTIFICATION](state, payload) {
    state.notification = payload;
  },
  [types.SET_STREAM](state, payload) {
    state.notification_stream.push(payload);
  },
  [types.SET_NOTIFICATION_ALL](state, payload) {
    state.notification_all = payload;
  },
  [types.SET_NOTIFICATION_TRANSIENT](state, payload) {
    state.notification_stream = payload;
  },
};
